'use client';

import { Toaster } from 'sonner';
import { useTheme } from '@/lib/ThemeContext';

/**
 * Sonner Toaster wrapper that follows the app's ThemeContext so toasts
 * are dark in dark mode and light in light mode. Bare visuals (background,
 * border, blur) live in app/globals.css under [data-sonner-toast] so they
 * pick up the active theme's HSL CSS vars automatically — no per-class
 * overrides needed here.
 *
 * richColors is intentionally off — it forces per-type background colors
 * (green success, red error, etc.) that visually fight the glassy
 * background. Type is still communicated via the type icon sonner draws.
 */
export default function ThemedToaster() {
  const { theme } = useTheme();
  return (
    <Toaster
      position="bottom-center"
      theme={theme === 'light' ? 'light' : 'dark'}
    />
  );
}
